// 商户入驻路由
export default [
  {
    path: '/businessDistrict',
    component: () => import('../pages/merchantsManage/businessDistrict/businessDistrict.vue'),
    name: 'businessDistrict',
    title: '商圈商户管理',
    meta: {
      title: '商圈商户管理',
    },
  },
  {
    path: '/merchantsManage',
    component: () => import('../pages/merchantsManage/merchantsManage.vue'),
    name: 'merchantsManage',
    title: '入驻商户管理',
    meta: {
      title: '入驻商户管理',
    },
  },
  {
    path: '/tieCard',
    component: () => import('../pages/merchantsManage/register/tieCard.vue'),
    name: 'tieCard',
    title: '商户绑卡',
    meta: {
      title: '商户绑卡',
    },
  },
  {
    path: '/merchantSign',
    component: () =>
      import('../pages/merchantsManage/register/merchantSign.vue'),
    name: 'merchantSign',
    title: '商户签约',
    meta: {
      title: '商户签约',
    },
  },
]
